// extracted by mini-css-extract-plugin
export default {"headers":"table_headers__Iwncn","body":"table_body__hMg8R","table":"table_table__U5ZJT","buttonCell":"table_buttonCell__W2J4u","inactiveRows":"table_inactiveRows__4JsHQ"};